<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0"> Nueva Venta </h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><router-link :to="{ name:'dashboard'}">Home</router-link></li>
            <li class="breadcrumb-item"><router-link :to="{ name:'pedidos'}">Venta</router-link></li>
            <li class="breadcrumb-item active">Nuevo</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <div class="card card-primary card-outline">
    <div class="card-body">
      <div class="row ">
        <div class="col-md-9">
            <div class="d-flex justify-content-between align-items-center">
            <label for="">
                <button class="btn btn-success" @click="abrirModal()"><i class="fas fa-shopping-cart"></i> Agregar Producto <i class="fas fa-search"></i></button>
            </label>
                <button class="btn btn-sm btn-danger" @click="cancelarVenta()"><i class="fas fa-eraser"></i> Limpiar</button>
            </div>
            <table class="table table-sm table-bordered table-striped">
              <thead class="bg-secondary">
                <tr>
                  <th>#</th>
                  <th class="text-center">x</th>  
                  <th>Producto</th>
                  <th>U/M de Venta</th>
                  <th width="8%">Precio</th>
                  <th width="8%">Cantidad</th>
                  <!--<th width="8%">Descuento %</th>-->
                  <th class="text-right">Importe</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tab,index) in arrayListProd" :key="tab.id">
                  <td>{{ index+1 }}</td>
                  <td class="text-center"><i class="fas fa-trash-alt text-danger" @click="eliminarItem(index)"></i></td>
                  <td><strong>{{ tab.producto }}</strong></td>
                  <td>{{ tab.umventa }}</td>
                  <td>
                    <input v-model.number="tab.precio" :readonly="readonlyP" @dblclick="enableEditingP" @blur="disableEditingP" @keyup.enter="disableEditingP" @keyup="recalcularItem(index)" class="form-control">
                  </td>
                  <td>
                    <input v-model.number="tab.cantidad" class="form-control" @keyup="recalcularItem(index)"/>
                  </td>
                  <!--<td>
                    <input v-model.number="tab.descuento" class="form-control" :readonly="readonly" @dblclick="enableEditing" @blur="disableEditing" @keyup.enter="disableEditing" @keyup="recalcularItem(index)">
                  </td>-->
                  <td class="text-right"><strong>{{ formattedTotal(tab.importe) }}</strong></td>
                </tr>
                <tr v-if="arrayListProd.length == 0">
                    <td colspan="8" class="text-danger">* Agregue un producto</td>
                </tr>
              </tbody>
            </table>
        </div>

        <div class="col-md-3">
            <div class="card card-warning">
                <div class="card-header">Datos del comprobante</div>
                <div class="card-body">
                  <div class="col-sm-12">
                    <div class="form-group">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                      <label><i class="fas fa-file-alt"></i> Comprobante</label>
                      <button class="btn btn-sm btn-danger" @click="limpiarFormulario">
                        <i class="fas fa-eraser"></i> Limpiar
                      </button>
                    </div>
                      <select class="form-control" v-model="idTipoComprob">
                        <option :value="0">=== Seleccione ===</option>
                        <option :value="tip.id"  v-for="tip in arrayTipoComp" :key="tip.id">{{ tip.nombre }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="exampleInputEmail1"><i class="far fa-calendar-check"></i> Fecha</label>
                        <input type="date" class="form-control" readonly v-model="fechaHoy">
                      </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1"> Aplicar</label>
                          <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="check_igv">
                            <label class="custom-control-label" for="customSwitch1">IGV {{load_igv}}%</label>
                          </div>
                        </div>
                      </div>
                  </div>
                <p></p>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label><i class="fas fa-address-card"></i> N° Documento del Cliente</label>
                      <div class="input-group">
                      <input type="number" class="form-control" placeholder="0" v-model="cliente_doc" :disabled="idTipoComprob==0"
                            @keyup.enter="buscarCliente"
                            :maxlength="maxLengthDoc"
                            @input="validateClienteDoc($event)">
                      <button class="btn btn-primary" @click="buscarCliente">
                        <i class="fas fa-search"></i>
                      </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label><i class="fas fa-user"></i> Nombre de Cliente</label>
                      <input type="text" class="form-control" placeholder="Nombre del cliente" v-model="cliente" style="text-transform:uppercase;">
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="exampleInputEmail1"><i class="fas fa-address-book"></i> Dirección del cliente</label>
                      <input type="text" class="form-control" placeholder="Dirección del cliente" v-model="cliente_dir" style="text-transform: uppercase;">
                    </div>
                  </div>

                </div>
              </div>

        </div>
      </div>

    
      <br>
      <div class="row">
        <div class="col-md-9">
            <div class="row">
              <div class="col-md-3">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">IGV</span>
                  </div>
                  <input type="text" class="form-control form-control-md bg-white" readonly :value="formattedTotal(sumaigv=sumaIgv)">
                </div>
              </div>
              <div class="col-md-3">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">DSCTO</span>
                  </div>
                  <input type="text" class="form-control form-control-md bg-white" readonly :value="formattedTotal(totalDscto=(sumaTotalSINdscto-sumaSubtotal))">
                </div>
              </div>
              <div class="col-md-3">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Subtotal</span>
                  </div>
                  <input type="text" class="form-control form-control-md bg-white" readonly :value="formattedTotal(subtotal=sumaSubtotal)">
                </div>
              </div>
              <div class="col-md-3">
                <button class="btn btn-primary btn-md" @click="grabarPedido()"><i class="fas fa-save"></i> Grabar Venta</button>
              </div>
            </div>
        </div>
     
        
        <div class="col-md-3">
            <div class="card border-primary mb-3">
                <div class="card-header bg-secondary text-white text-center">
                  <h5 class="mb-0">TOTAL DE VENTA</h5>
                </div>
                <div class="card-body bg-light">
                  <input type="text" class="form-control text-center font-weight-bold form-control-lg border-0 bg-light" 
                         readonly :value="formattedTotal(sumatotal=sumaTotal)" style="font-size: 2rem;">
                </div>
              </div>
        </div>
      </div>
      <br>
      
    </div>
  </div><!-- /.card -->


    <!-- Modal -->
  <div v-if="showModal">
    <div class="modal">
      <div class="modal-overlay"></div>
      
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title">Productos</h5>
            <button type="button" class="close" aria-label="Close">
              <span aria-hidden="true" @click="cerrarModal()">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">Productos: </span>
              </div>
              <input type="text" class="form-control" v-model="txtBuscar" placeholder="Buscar producto" @keyup="listarProducto(txtBuscar)">
              <div class="input-group-append">
                <span class="input-group-text"><i class="fas fa-search"></i></span>
              </div>
            </div>


            <div class="table-responsive">
              <div style="height: 300px; overflow: auto;">
              <table class="table table-sm table-bordered cabeceraFija tabla">
                <thead class="bg-primary">
                  <tr>
                    <th>Producto</th>
                    <th>Precios</th>
                    <th>Stock Unidad</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="p in arrayProducto" :key="p.id" @click="agregarTablaVenta(p)" >
                    <td>{{p.producto}} - {{p.marca}}. {{p.modelo?p.modelo:''}} {{p.serie?p.serie:''}}</td>
                    <td>
                        <div class="input-group mb-1" >
                            <div class="input-group-prepend">
                                <span class="input-group-text" style="font-size: 11pt;">{{p.nombre_unidad_medida}} - {{ p.tipoVenta }}</span>
                            </div>
                            <div class="input-group-append">
                                <button class="btn btn-primary" type="button" style="font-size: 12pt;z-index: 0;" >S/ {{ p.precio }}</button>
                            </div>
                        </div>
                    </td>
                    <td v-text="p.stock"></td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-dark" @click="cerrarModal()">Cerrar</button>
          </div>
        </div>  
    </div>
  </div>
    <!-- Loading Overlay -->
    <div v-if="loading" class="loading-overlay">
        <div class="spinner-border text-light" role="status" style="width: 5rem; height: 5rem;">
        <span class="sr-only">Grabando...</span>
        </div>
        <p class="text-light mt-3">Procesando pedido, espere...</p>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue' //sobre fechas
import { DateTime } from 'luxon' //timezone manejo
    export default{
      setup() {
        const fechaHoy = ref('');
        onMounted(() => {
          const today = DateTime.now().setZone('America/Lima');
          fechaHoy.value = today.toISODate();
        });
        return {
          fechaHoy,
        };
      },
      data(){
          return{
            txtBuscar:'',
            arrayProducto:[],
            igv:0,
            load_igv:'',
            arrayMoneda:[],
            moneda:1, //soles
            check_igv: false,
            readonly: true,
            readonlyP: true,
            
            idTipoComprob:0,
            arrayTipoComp:[],

            showModal: false,
            idEmpresa:'',
            rucEmpresa:'',

            arrayListProd:[],
            errorGenerar:0,
            arrayMostMsjGenerar:[],
            cliente:'',
            cliente_doc:'',
            cliente_dir:'',

            nombreUsuario:'',
            idUsuario:'',
            idSucursal:'',
            permisoDscto:'',

            loading:false,
          }
      },
      computed: {
        maxLengthDoc() {
            if (this.idTipoComprob == 1) return 8;   // DNI
            if (this.idTipoComprob == 2) return 11;  // RUC
            return 0;                                // nada
        },
        fechaFormateada() {
          if (this.fechaHoy) {
            const date = new Date(this.fechaHoy);
            const options = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            };
            return date.toLocaleDateString(undefined, options);
          } else {
            return '';
          }
        },
        sumaSubtotal(){
          return this.arrayListProd.reduce((importe,item) => importe + item.importe,0)
        },
        sumaTotal(){
          var sub = this.arrayListProd.reduce((importe,item) => importe + item.importe,0)
          var totalIgv = this.arrayListProd.reduce((igv,item) => igv + item.igv,0)
          return sub + totalIgv
        },
        sumaIgv(){
          return this.arrayListProd.reduce((igv,item) => igv + item.igv,0)
        },
        sumaTotalSINdscto(){
          return this.arrayListProd.reduce((sumatoria, item) => (sumatoria + (item.cantidad * item.precio)), 0);
        }
      },
      methods:{
        listarProducto(txtBuscar){
          let me = this
          this.$axios.get(`apinventario/precioproductoventa/?page=1&search=${txtBuscar}`)
          .then(function(response){
              me.arrayProducto = response.data.results
          })
        },
        abrirModal(){
          this.showModal = true
          this.listarProducto('')
        },
        cerrarModal(){
          this.showModal = false
          this.arrayProducto=[]
          this.txtBuscar=''
        },
        agregarTablaVenta(data=[]){//alert(data.total+ ' '+ dato.proporcion)
        
          if(parseFloat(data.stock) < parseFloat(data.proporcion) ){
            this.$toastr.error('Producto sin STOCK','Atencion!')
            return
          }
          this.arrayListProd.push({
            idVarianteP: data.idVarianteP,
            idPrecioProducto: data.id,
            producto: `${data.producto} ${data.marca ? data.marca : ''} ${data.modelo ? data.modelo : ''} ${data.serie ? data.serie : ''}`.trim(),
            umventa: data.nombre_unidad_medida,
            idUnidadMedida: data.idUnidadMedida,
            precio: data.precio,
            //proporcionVentaUM:data.proporcion,
            proporcion: data.proporcion,
            stock: data.stock,
            cantidad: 1,
            descuento: 0,
            importe: data.precio * 1,
            igv: (data.precio * 1) * (this.igv/100)
          })
          this.cerrarModal()
        },
        recalcularItem(index){
          const item = this.arrayListProd[index]
          if(item.cantidad * item.proporcion > item.stock){
            this.$toastr.error('La cantidad '+item.cantidad+' supera STOCK','NO HAY STOCK!')
            item.cantidad = 1
            return
          }
          let descuen = (item.precio * (item.descuento)/100).toFixed(1) //calculamos si hay descuento
          console.log(descuen)
          item.importe = (item.precio - descuen) * item.cantidad
          item.igv = (item.precio * item.cantidad) * (this.igv/100)
        },
        formattedTotal(amount) {
            return new Intl.NumberFormat('es-PE', {
            style: 'currency',
            currency: 'PEN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            }).format(amount);
        },
        eliminarItem(index){
          this.arrayListProd.splice(index,1)
        },
        validarVenta(){
          this.errorGenerar = 0
          this.arrayMostMsjGenerar = []
          if(!this.arrayListProd.length) this.arrayMostMsjGenerar.push("Agregue un producto a la lista")
          //validar cantidad y costo de la tabla arrayListProd
          this.arrayListProd.forEach(element => {
            if(element.importe <= 0 || isNaN(element.importe)){
              this.arrayMostMsjGenerar.push("Revisar la tabla de productos, cantidad y precio deben ser números positivos")
              return
            }
          })
          if(this.cliente){
            if(this.cliente.length < 3) this.arrayMostMsjGenerar.push("El nombre de cliente debe tener más de 3 letras")
          } 
          if(!this.cliente) this.arrayMostMsjGenerar.push("Ingrese nombre de cliente")
          if(!this.idTipoComprob) this.arrayMostMsjGenerar.push("Seleccione un tipo de comprobante")
          if(this.arrayMostMsjGenerar.length) this.errorGenerar = 1
          return this.errorGenerar
        },
        grabarPedido(){
          if(this.validarVenta()){
            this.arrayMostMsjGenerar.forEach(element => {
              this.$toastr.error(element,'Atencion!')
            });
            return
          }
          let me = this
          this.$swal.fire({
          title: 'Generar nueva venta',
          text: "Esta seguro?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, generar'
          }).then((result) => {
            me.loading=true
            if (result.isConfirmed) {
              let detalleArray = this.arrayListProd.map((detalle)=>{
              return {
                idVarianteP: detalle.idVarianteP,
                producto: detalle.producto,
                umVenta: detalle.umventa,
                idUMVenta: detalle.idUnidadMedida,
                precio:detalle.precio,
                //proporcionVentaUM:detalle.proporcionVentaUM,
                proporcion:detalle.proporcion,
                stock: detalle.total,
                cantidad:detalle.cantidad,
                descuento: detalle.descuento,
                importe:detalle.importe,
              }
              })
              this.$axios.post(`apiventa/pedidos/`, { //URL GRABAR PEDIDO
                  idUsuario: me.idUsuario,
                  idComprob:me.idTipoComprob,
                  idCliente:me.idCliente,
                  cliente: (me.cliente.toUpperCase()).trim(),
                  cliente_doc:me.cliente_doc,
                  cliente_dir: (me.cliente_dir.toUpperCase()).trim(),
                  estado:'Pendiente',
                  numero:null,
                  subtotal: me.subtotal,
                  igvTotal: parseFloat(me.sumaigv).toFixed(2), // redondear a dos decimales la suma del IGV
                  idMoneda: me.moneda,
                  detalles: detalleArray,
                  idSucursal:me.idSucursal,
                  dsctoTotal: me.totalDscto,
                  idEmpresa:me.idEmpresa,
                  rucEmpresa:me.rucEmpresa,
              }).
              then((response)=>{
                if(localStorage.getItem('grupo_id') == 4 || localStorage.getItem('grupo_id') == 1){ // usuario admin y vendedor_cobrar
                    const numero = response.data.numero
                    const fecha = response.data.fecha
                    me.$router.push({
                        name: 'caja',
                        query:{
                            pedido: numero,
                            fecha: fecha,
                        }
                    })
                }else{
                    console.log(response.data)
                    me.$router.push('/pedidos/')
                    me.$toastr.success('Nuevo Pedido generado', 'Excelente!')
                    me.$socket.send(JSON.stringify({'message':'nuevo pedido'}))
                }

              }).
              catch((error)=>{
                console.error(error);
                if (error.response && error.response.data && error.response.data.error) {
                    me.$toastr.error(error.response.data.error, 'Error');
                } else {
                    me.$toastr.error('Error al generar pedido', 'Error');
                }
              })
              .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
            }
            else{
                me.loading=false
            }
          })
          
        },
        cancelarVenta(){
          this.cliente=''
          this.cliente_doc=''
          this.cliente_dir=''
          this.idTipoComprob=0
          this.check_igv = false
          this.arrayListProd=[]
        },
        listarCompro(){
          let me = this
          this.$axios.get(`apiempresa/tipocomprobante/`)
          .then(function(response){
            if(response.data.length){
                me.arrayTipoComp = response.data.slice(0,2)
            }
          })
        },
        listarIgv(){
            let me = this
            this.$axios.get(`apiempresa/conceptoconfig/?idEmpresa=${me.idEmpresa}`)
            .then(function(response){
              if(response.data.length){
                me.load_igv = response.data[0]['impuesto']
              }else{
                me.$toastr.error('El IGV no esta configurado','Atencion!')
              }
            })
        },
        changeIgv(){
          this.$nextTick(() => {
            this.igv = this.check_igv ? 18 : 0;
            
          });
        },
        listarMoneda(){
          let me = this
          this.$axios.get(`apiempresa/moneda/`)
          .then(function(response){
            if(response.data.length){
                me.arrayMoneda = response.data
            }
          })
        },
        enableEditing() {
            
          if(this.permisoDscto && this.permisoDscto == true){
            this.readonly = false; // Cambia readonly a falso cuando se hace doble clic
          }else{
            this.$toastr.info('No cuenta con permiso para esta función','Sin autorización!')
          }
          
        },
        disableEditing() {
          this.readonly = true; // Cambia readonly a verdadero cuando se pierde el foco o se presiona Enter
        },
        enableEditingP() {
            
          if(this.permisoDscto && this.permisoDscto === 'true'){
            this.readonlyP = false; // Cambia readonly a falso cuando se hace doble clic
          }else{
            this.$toastr.info('! No cuenta con permiso para esta función','Sin autorización!')
          }
          
        },
        disableEditingP() {
          this.readonlyP = true; // Cambia readonly a verdadero cuando se pierde el foco o se presiona Enter
        },
        validarBusCliente(){
            const doc = String(this.cliente_doc)
            if(this.idTipoComprob==1){

                if(doc.length !== 8){
                    this.$toastr.error('El Dni debe ser 8 digitos','Error')
                    return 1
                }
            }
            if(this.idTipoComprob==2){
                if(doc.length !== 11){
                    this.$toastr.error('El Ruc debe ser 11 digitos','Error')
                    return 1
                }
            }
            return 0
        },
        validateClienteDoc(e) {
            if (!e || !e.target) return;
            // Solo números
            let value = e.target.value.replace(/\D/g, "");

            // Limitar longitud
            const max = this.maxLengthDoc;
            if (max > 0 && value.length > max) {
            value = value.slice(0, max);
            }

            this.cliente_doc = value;
        },
        buscarCliente() {
            this.cliente = ''
            this.cliente_dir = ''
            if(this.validarBusCliente() == 0){
                let me = this
                this.$axios.get(`apiventa/clientes/buscar/`, {
                    params: {
                    numDocumento: me.cliente_doc
                    }
                })
                .then(function(response) {
                    if (response.data && response.data.numDocumento) {
                        me.cliente_doc = response.data.numDocumento
                        me.cliente = response.data.nombre
                        me.cliente_dir = response.data.direccion
                    }else{
                        me.$axios.get(`apiventa/consulta-dni-ruc/?numero=${me.cliente_doc}&idTipoComprob=${me.idTipoComprob}`)
                        .then(response => {
                            const data = response.data
                            if(data.numeroDocumento){
                                me.cliente_doc = data.numeroDocumento
                                me.cliente = data.nombres
                                me.cliente_dir = data.direccion
                            }
                            if(data.message){
                                me.$toastr.error('Error: '+data.message)
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            me.$toastr.error('Error al buscar')
                        }) 
                    }
                })
            }           
        },
        limpiarFormulario(){
            this.cliente_doc = ''
            this.cliente = ''
            this.cliente_dir = ''
            this.idCliente = 0
            this.idTipoComprob = 0
        }
      },
      watch: {
        check_igv: {
          handler(newVal) {
            this.igv = newVal ? this.load_igv : 0;
            if(this.arrayListProd.length){ // Recalcular el IGV de la lista de productos
              this.arrayListProd.forEach(item => {
                item.igv = (item.precio * item.cantidad) * (this.igv/100)
              })
            }
            
          },
          immediate: true // Esto garantiza que se ejecute el watcher cuando se carga el componente por primera vez.
        }
      },
      mounted(){
        this.nombreUsuario = localStorage.getItem('username')
        this.idUsuario = localStorage.getItem('idusuario')
        this.idSucursal = localStorage.getItem('idSucursal')
        this.permisoDscto = localStorage.getItem('permisoDscto')
        this.idEmpresa = localStorage.getItem('idEmpresa')
        this.rucEmpresa = localStorage.getItem('rucEmpresa')
        this.listarCompro()
        this.listarIgv()
        this.listarMoneda()
      }
  }
</script>

<style scoped>.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
}
.modal-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content{
  width: 70%;
  background-color: white;
  margin-top: 100px;
}
.cabeceraFija thead th {
  position: sticky;
  top: 0;
  background-color:dodgerblue; /* Color de fondo para resaltar la cabecera */
  z-index: 1; /* Asegura que la cabecera se superponga sobre el contenido */
}
.tabla tr:hover {
    background-color: #c0c0c0; /* color de fondo al pasar el mouse */
    cursor: pointer;          /* opcional: cambia el cursor */
  }
  .loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
</style>